export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '__COMMITMENT_DETAILS': 'Commitment Details',
    '__VIEW_COMMITMENT': 'View Commitment',
    '__NO_DATA_FOUND': 'No Data is available',
    '__DIRECT_REPORT': 'Direct Report',
    '__START_DATE': 'Start Date',
    '__METRIC': 'Metric',
    '__FOCUS': 'Focus',
    '__START_ACTUAL': 'Start Actual',
    '__ASSESSED_ACTUAL': 'Assessed Actual',
    '____IMPROVEMENT': '% Improvement',
    '__STATE': 'State',
    '__WINS_AT': 'Wins At',
    '__CLOSE': 'Close',
    '__THE_VALUE_AT_WHICH': 'The value at which the commitment will be considered winning',
    '__THE_VALUE_USER_ACHIEVED': 'The value user achieved at the selected evaluation range that was used to determine if the commitment was winning'
};
